module.exports = new __parcel__URL__("circled-arrow.f4ab57f3.png").toString();